export default "__VITE_ASSET__a043c02a__"